import T from "i18n-react"
import en from "ROOT/i18n/en"

export const setDictionary = () => new Promise(resolve => {
  T.setTexts(en)
  resolve()
})

const t = (key, { defaultKey, params = {} } = {}) => {
  const opts = { ...params }
  if (defaultKey) opts.notFound = () => t(defaultKey)
  return T.translate(key, opts)
}

export default t
